export async function formatterFileFrontToBack(anexos, respostaApi, atendenteId = 0) {
  const formData = new FormData();

  for (let anexo of anexos) {
    delete anexo.key;
    delete anexo.data;
    formData.append('FileData', anexo);
  }

  formData.append('formularioId', respostaApi?.id);
  formData.append('localizadorFormulario', respostaApi?.localizador);
  formData.append('atendenteId', atendenteId);
  formData.append('id', 0);

  return formData;
}
